<template>
	<div class="textdetails">
		<!-- <div class="shareto">
			分享至:
			<img class="imgwx" src="../static/img/wechat@2x.png" alt="" @click="wxshare" />
			<img class="imgqq" src="../static/img/qq@2x.png" alt="" @click="qqshare" />
		</div> -->

		<div class="title">{{ informv.title }}</div>
		<div class="timesource">
			{{ informv.datetime }}
			<span style="margin-left: 20px;" v-if='informv.source'>来源:{{ informv.source }}</span>
		</div>
		<div class="line"></div>

		<div class="msg" v-html="informv.contentval"></div>
	</div>
</template>

<script>
export default {
	props: ['informdata'],
	data: function() {
		return {
			informv: {}
		};
	},

	watch: {
		// informdata: function(newVal, oldVal) {
		// 	this.informv = newVal;
		//    }
	},

	mounted() {
		this.informv = this.informdata;
	},

	methods: {
		wxshare() {
			
		},
		// https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey
		// http://connect.qq.com/widget/shareqq/index.html?url={{url}}&title={{title}}&source={{source}}&desc={{desc}}&pics={{image}}&summary={{summary}}
		qqshare() {
			window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(document.location.href));
			// window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + escape(document.location.href));
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.textdetails {
	.shareto {
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		.imgwx {
			cursor: pointer;
			margin-left: 20px;
			height:22px;
			width:26px;
		}
		.imgqq {
			cursor: pointer;
			margin-left: 20px;
			height:22px;
			width:18px;
		}
	}
	.title {
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		text-align: center;
		margin-top: 40px;
		min-height:50px;
		line-height:50px;
	}
	.timesource {
		font-size: 16px;
		color: #666666;
		text-align: center;
		height: 30px;
		line-height:30px;
	}
	.line {
		width: 100%;
		height: 1px;
		background-color: #ededed;
	}

	.msg {
		padding: 40px;
	}
	
	.msg::-webkit-scrollbar {
		display: none;
	}
}
</style>
<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>